import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { isNullOrUndefined } from '@app/shared/helpers';
import { ClinicForm } from '@models/forms/clinic-form';
import { FormType, formTypeNames } from '@models/forms/form-type.enum';
import { ServiceTemplateType } from '@models/service/service-template-type';
import { ClinicFormService } from '@services/form.service';
import { FormatterService } from '@services/formatter.service';
import { ServiceTemplateTypeService } from '@services/service-template-type.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-form-edit',
  templateUrl: './form-edit.component.html',
  styleUrls: ['./form-edit.component.less'],
})
export class FormEditComponent implements OnInit, OnDestroy {
  loading = false;
  disableGrid = true;
  unsub: Subject<void> = new Subject<void>();
  formId: number;

  form: FormGroup;
  addOrUpdate: String;
  isNew = false;

  formTypes: FormType[] = [];
  serviceTemplateTypes: ServiceTemplateType[] = [];

  FormType = FormType;
  formTypeNames = formTypeNames;

  constructor(
    private fb: FormBuilder,
    private clinicFormService: ClinicFormService,
    private serviceTemplateTypesService: ServiceTemplateTypeService,
    public formatterService: FormatterService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.route.params.pipe(takeUntil(this.unsub)).subscribe((params) => {
      if (+params['id'] === this.clinicFormService.defaultId) {
        this.isNew = true;
        this.addOrUpdate = 'Create';
        this.formId = 0;
      } else {
        this.formId = +params['id'];
        this.isNew = false;
        this.addOrUpdate = 'Update';
      }

      this.getServiceTemplateTypesList();
      this.initForm();

      this.clinicFormService.getFormById(this.formId).subscribe((form) => {
        if (!isNullOrUndefined(form)) {
          this.setFormValues(form);
        }
      });
    });
  }

  getServiceTemplateTypesList() {
    this.serviceTemplateTypes = [];
    this.serviceTemplateTypesService.getAllServiceTemplateTypes().subscribe((res) => {
      res.forEach((type) => {
        const typeData = type;
        const pushItem: ServiceTemplateType = {
          id: typeData.id,
          name: typeData.name,
        };
        this.serviceTemplateTypes.push(pushItem);
      });
    });
  }
  private initForm() {
    this.form = this.fb.group({
      id: new FormControl(this.formId, [Validators.required]),
      formType: new FormControl(null, [Validators.required]),
      name: new FormControl('', [Validators.required]),
      notes: new FormControl(''),
      formDefinition: new FormControl(''),
    });
  }

  private setFormValues(form: ClinicForm) {
    this.form.controls['id'].setValue(form.id);
    this.form.controls['formType'].setValue(form.formType);
    this.form.controls['name'].setValue(form.name);
    this.form.controls['notes'].setValue(form.notes);
    this.form.controls['formDefinition'].setValue(form.formDefinition);
  }

  isFormDisabled(): boolean {
    return !this.form.valid;
  }

  onSubmit() {
    this.loading = true;

    try {
      if (this.isNew) {
        this.clinicFormService.addForm(this.form.value).subscribe(() => {
          this.router.navigate(['/management/forms', { outlets: { 'action-panel': null } }]);
        });
      } else {
        this.clinicFormService.updateForm(this.form.value).subscribe(() => {
          this.router.navigate(['/management/forms', { outlets: { 'action-panel': null } }]);
        });
      }
    } catch {
      this.loading = false;
    }
  }

  cancelUpdate() {
    this.clinicFormService.formChangeCancelled.next();
    this.router.navigate(['/management/forms', { outlets: { 'action-panel': null } }]);
  }

  ngOnDestroy() {
    this.unsub.next();
    this.unsub.complete();
  }
}
